import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";

export const useTelaEstreita = (ate: Breakpoint = "sm"): boolean => {
  const tema = useTheme();
  return useMediaQuery(tema.breakpoints.down(ate));
};

// telas de toque nao tem hover: o SpeedDial precisa abrir por clique nesses aparelhos
export const useSemHover = (): boolean => useMediaQuery("(hover: none)");

export interface ComTelaEstreita {
  telaEstreita?: boolean;
}

// componentes de classe nao usam hook: o HOC injeta a leitura reativa do viewport como prop
export function comTelaEstreita<P extends ComTelaEstreita>(
  Componente: React.ComponentType<P>,
  ate: Breakpoint = "sm"
): React.FC<Omit<P, "telaEstreita">> {
  const Envolvido: React.FC<Omit<P, "telaEstreita">> = (props) => {
    const telaEstreita = useTelaEstreita(ate);
    return <Componente {...(props as P)} telaEstreita={telaEstreita} />;
  };
  Envolvido.displayName = `comTelaEstreita(${Componente.displayName || Componente.name || "Componente"})`;
  return Envolvido;
}
